import axios from 'axios';
import { getConfig } from '../config';
import { AdminApiDomain, getAdminApiUrl } from '../config/ApiRouting';
import type { CategoryMapping, CategoryMappingUpsert } from '../models/CategoryMapping';

interface SaveCategoryMappingResponse {
  totalSaved: number;
  mappings: CategoryMapping[];
}

export class CategoryMappingClient {
  private readonly baseUrl: string;
  private readonly apiKey: string;

  constructor() {
    this.baseUrl = getAdminApiUrl(AdminApiDomain.SOURCING);
    this.apiKey = getConfig().apiKey;
  }

  async getAllMappings(): Promise<CategoryMapping[]> {
    const url = `${this.baseUrl}/sourcing/gpCategoriesToWp/all`;
    const response = await axios.get<CategoryMapping[]>(url, {
      headers: { 'X-API-Key': this.apiKey },
    });
    return response.data;
  }

  async saveMappings(mappings: CategoryMappingUpsert[]): Promise<SaveCategoryMappingResponse> {
    const url = `${this.baseUrl}/sourcing/gpCategoriesToWp`;
    const response = await axios.post<SaveCategoryMappingResponse>(url, mappings, {
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': this.apiKey,
      },
    });
    return response.data;
  }
}

export const categoryMappingClient = new CategoryMappingClient();
